import styled from 'styled-components'
import SMSIcon from '../../asset/sms-icon.svg'
import EmailIcon from '../../asset/email-con.svg'

export const MockModalContainer = styled.div`
  background: rgba(248, 248, 248, 0.95);
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  //   backdrop-filter: blur(54.3656px);
  border-radius: 13px;
  position: absolute;
  line-height: 1.5;
  margin: 0 10px;
  text-size-adjust: 100%;
  color: #000000;
  top: ${({ showModal }) => (showModal ? '0' : '-50%')};
  right: 0;
  left: 0;
  transition: top 0.3s ease-in-out;
`

export const MockModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #8a8a8f;
  padding: 9px 16px 7px 35px;
`
export const SMSLable = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  &:before {
    background-image: url(${({ type }) =>
      type === 'SMS' ? SMSIcon : EmailIcon});
    width: 20px;
    height: 20px;
    content: ' ';
    display: block;
    position: absolute;
    box-sizing: border-box;
    background-repeat: no-repeat;
    z-index: 10;
    left: 8px;
    top: 8px;
  }
`
export const SMSTime = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
`
export const MockModalContent = styled.div`
  padding: 0 12px 10px 16px;
`
export const MockModalTitle = styled.div`
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
`
export const MockModalText = styled.div`
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
`
